







































import Vue from 'vue';
import Report from '@/components/Report.vue';
import ReportPage from '@/components/ReportPage.vue';
import ChartOSWorldwide from '@/components/ChartOSWorldwide.vue';
import ChartOSHistory from '@/components/ChartOSHistory.vue';
import ChartOEMsWorldwide from '@/components/ChartOEMsWorldwide.vue';
import ChartSurface from '@/components/ChartSurface.vue';

export default Vue.extend({
  name: 'report201806',
  components: {
    'adduplex-report': Report,
    'report-page': ReportPage,
    'chart-os-worldwide': ChartOSWorldwide,
    'chart-os-history': ChartOSHistory,
    'chart-surface': ChartSurface,
  },
  data() {
    return {
      osWorldwideData: [
          {'OS version': 'Windows 10 CU & older', 'Share': 0.0249},
          {'OS version': 'Windows 10 FCU (1709)', 'Share': 0.0182},
          {'OS version': 'Windows 10 A18U (1803)', 'Share': 0.1359},
          {'OS version': 'Windows 10 O18U (1809)', 'Share': 0.2502},
          {'OS version': 'Windows 10 M19U (1903)', 'Share': 0.5655, 'featured': true},
          {'OS version': 'Windows 10 (Insiders)', 'Share': 0.0054}],
      osHistoryData: [
                    {
                        // interpolated values
                        'date': '7/29/2015',
                        'Windows 10 (1507)': '1',
                    },
                    {
                        // interpolated values
                        'date': '11/10/2015',
                        'Windows 10 (1507)': '1',
                        'Windows 10 (1511)': '0',
                    },
                    {
                        // interpolated values
                        'date': '8/2/2016',
                        'Windows 10 (1507)': '0.1269',
                        'Windows 10 (1511)': '0.8731',
                        'Windows 10 AU (1607)': '0',
                    },
                    {
                        'date': '8/22/2016',
                        'Windows 10 (1507)': '0.0613',
                        'Windows 10 (1511)': '0.7761',
                        'Windows 10 AU (1607)': '0.1626',
                    },
                    {
                        'date': '9/20/2016',
                        'Windows 10 (1507)': '0.0513',
                        'Windows 10 (1511)': '0.6022',
                        'Windows 10 AU (1607)': '0.3465',
                    },
                    {
                        'date': '10/19/2016',
                        'Windows 10 (1507)': '0.0403',
                        'Windows 10 (1511)': '0.1882',
                        'Windows 10 AU (1607)': '0.7715',
                    },
                    {
                        'date': '11/21/2016',
                        'Windows 10 (1507)': '0.0289',
                        'Windows 10 (1511)': '0.1341',
                        'Windows 10 AU (1607)': '0.8369',
                    },
                    {
                        'date': '12/19/2016',
                        'Windows 10 (1507)': '0.0260',
                        'Windows 10 (1511)': '0.1049',
                        'Windows 10 AU (1607)': '0.8691',
                    },
                    {
                        'date': '2/20/2017',
                        'Windows 10 (1507)': '0.0208',
                        'Windows 10 (1511)': '0.0709',
                        'Windows 10 AU (1607)': '0.9083',
                    },
                    {
                        'date': '3/21/2017',
                        'Windows 10 (1507)': '0.0201',
                        'Windows 10 (1511)': '0.0602',
                        'Windows 10 AU (1607)': '0.9196',
                    },
                    {
                        // interpolated values
                        'date': '4/5/2017',
                        'Windows 10 (1507)': '0.0191',
                        'Windows 10 (1511)': '0.0601',
                        'Windows 10 AU (1607)': '0.9208',
                        'Windows 10 CU (1703)': '0',
                    },
                    {
                        'date': '4/24/2017',
                        'Windows 10 (1507)': '0.01783',
                        'Windows 10 (1511)': '0.05996',
                        'Windows 10 AU (1607)': '0.82430',
                        'Windows 10 CU (1703)': '0.09791',
                    },
                    {
                        'date': '5/22/2017',
                        'Windows 10 (1507)': '0.01563',
                        'Windows 10 (1511)': '0.04589',
                        'Windows 10 AU (1607)': '0.75766',
                        'Windows 10 CU (1703)': '0.18081',
                    },
                    {
                        'date': '6/26/2017',
                        'Windows 10 (1507)': '0.01489',
                        'Windows 10 (1511)': '0.04149',
                        'Windows 10 AU (1607)': '0.58552',
                        'Windows 10 CU (1703)': '0.35810',
                    },
                    {
                        'date': '7/18/2017',
                        'Windows 10 (1507)': '0.00854',
                        'Windows 10 (1511)': '0.02630',
                        'Windows 10 AU (1607)': '0.46197',
                        'Windows 10 CU (1703)': '0.50320',
                    },
                    {
                        'date': '8/22/2017',
                        'Windows 10 (1507)': '0.00886',
                        'Windows 10 (1511)': '0.02796',
                        'Windows 10 AU (1607)': '0.30267',
                        'Windows 10 CU (1703)': '0.66051',
                    },
                    {
                        'date': '9/20/2017',
                        'Windows 10 (1507)': '0.00774',
                        'Windows 10 (1511)': '0.02721',
                        'Windows 10 AU (1607)': '0.23386',
                        'Windows 10 CU (1703)': '0.73119',
                    },
                    {
                        // interpolated values
                        'date': '10/17/2017',
                        'Windows 10 (1507)': '0.0073',
                        'Windows 10 (1511)': '0.0206',
                        'Windows 10 AU (1607)': '0.1857',
                        'Windows 10 CU (1703)': '0.7445',
                        'Windows 10 FCU (1709)': '0',
                    },
                    {
                        'date': '10/24/2017',
                        'Windows 10 (1507)': '0.0071',
                        'Windows 10 (1511)': '0.0189',
                        'Windows 10 AU (1607)': '0.1732',
                        'Windows 10 CU (1703)': '0.7480',
                        'Windows 10 FCU (1709)': '0.0528',
                    },
                    {
                        'date': '11/27/2017',
                        'Windows 10 (1507)': '0.0059',
                        'Windows 10 (1511)': '0.0154',
                        'Windows 10 AU (1607)': '0.1367',
                        'Windows 10 CU (1703)': '0.6375',
                        'Windows 10 FCU (1709)': '0.2046',
                    },
                    {
                        'date': '12/20/2017',
                        'Windows 10 (1507)': '0.0053',
                        'Windows 10 (1511)': '0.0133',
                        'Windows 10 AU (1607)': '0.1051',
                        'Windows 10 CU (1703)': '0.3382',
                        'Windows 10 FCU (1709)': '0.5380',
                    },
                    {
                        'date': '1/22/2018',
                        'Windows 10 (1507)': '0.0050',
                        'Windows 10 (1511)': '0.0113',
                        'Windows 10 AU (1607)': '0.0658',
                        'Windows 10 CU (1703)': '0.1726',
                        'Windows 10 FCU (1709)': '0.7454',
                    },
                    {
                        'date': '2/20/2018',
                        'Windows 10 (1507)': '0.0050',
                        'Windows 10 (1511)': '0.0098',
                        'Windows 10 AU (1607)': '0.0509',
                        'Windows 10 CU (1703)': '0.0813',
                        'Windows 10 FCU (1709)': '0.8530',
                    },
                    {
                        'date': '3/26/2018',
                        'Windows 10 (1507)': '0.0048',
                        'Windows 10 (1511)': '0.0079',
                        'Windows 10 AU (1607)': '0.0364',
                        'Windows 10 CU (1703)': '0.0431',
                        'Windows 10 FCU (1709)': '0.9077',
                    },
                    {
                        'date': '4/25/2018',
                        'Windows 10 (1507)': '0.0038',
                        'Windows 10 (1511)': '0.0074',
                        'Windows 10 AU (1607)': '0.0295',
                        'Windows 10 CU (1703)': '0.0318',
                        'Windows 10 FCU (1709)': '0.9276',
                    },
                    {
                        // interpolated values
                        'date': '4/30/2018',
                        'Windows 10 (1507)': '0.0036',
                        'Windows 10 (1511)': '0.0073',
                        'Windows 10 AU (1607)': '0.0283',
                        'Windows 10 CU (1703)': '0.0299',
                        'Windows 10 FCU (1709)': '0.9309',
                        'Windows 10 A18U (1803)': '0',
                    },
                    {
                        'date': '5/29/2018',
                        'Windows 10 (1507)': '0.0036',
                        'Windows 10 (1511)': '0.0072',
                        'Windows 10 AU (1607)': '0.0282',
                        'Windows 10 CU (1703)': '0.0292',
                        'Windows 10 FCU (1709)': '0.4313',
                        'Windows 10 A18U (1803)': '0.5005',
                    },
                    {
                        'date': '6/26/2018',
                        'Windows 10 (1507)': '0.0039',
                        'Windows 10 (1511)': '0.0075',
                        'Windows 10 AU (1607)': '0.0248',
                        'Windows 10 CU (1703)': '0.0239',
                        'Windows 10 FCU (1709)': '0.1568',
                        'Windows 10 A18U (1803)': '0.7831',
                    },
                    {
                        'date': '7/25/2018',
                        'Windows 10 (1507)': '0.0038',
                        'Windows 10 (1511)': '0.0063',
                        'Windows 10 AU (1607)': '0.0216',
                        'Windows 10 CU (1703)': '0.0208',
                        'Windows 10 FCU (1709)': '0.1030',
                        'Windows 10 A18U (1803)': '0.8445',
                    },
                    {
                        'date': '8/22/2018',
                        'Windows 10 (1507)': '0.0039',
                        'Windows 10 (1511)': '0.0072',
                        'Windows 10 AU (1607)': '0.0209',
                        'Windows 10 CU (1703)': '0.0193',
                        'Windows 10 FCU (1709)': '0.0784',
                        'Windows 10 A18U (1803)': '0.8703',
                    },
                    {
                        'date': '9/25/2018',
                        'Windows 10 (1507)': '0.0030',
                        'Windows 10 (1511)': '0.0059',
                        'Windows 10 AU (1607)': '0.0180',
                        'Windows 10 CU (1703)': '0.0169',
                        'Windows 10 FCU (1709)': '0.0567',
                        'Windows 10 A18U (1803)': '0.8994',
                    },
                    {
                        // interpolated values
                        'date': '10/2/2018',
                        'Windows 10 (1507)': '0.0029',
                        'Windows 10 (1511)': '0.0056',
                        'Windows 10 AU (1607)': '0.0174',
                        'Windows 10 CU (1703)': '0.0164',
                        'Windows 10 FCU (1709)': '0.0523',
                        'Windows 10 A18U (1803)': '0.9054',
                        'Windows 10 O18U (1809)': '0',
                    },
                    {
                        // interpolated values - rollout stopped
                        'date': '10/9/2018',
                        'Windows 10 (1507)': '0.0027',
                        'Windows 10 (1511)': '0.0054',
                        'Windows 10 AU (1607)': '0.0168',
                        'Windows 10 CU (1703)': '0.0160',
                        'Windows 10 FCU (1709)': '0.0478',
                        'Windows 10 A18U (1803)': '0.8885',
                        'Windows 10 O18U (1809)': '0.0228',
                    },
                    {
                        'date': '10/30/2018',
                        'Windows 10 (1507)': '0.0031',
                        'Windows 10 (1511)': '0.0055',
                        'Windows 10 AU (1607)': '0.0180',
                        'Windows 10 CU (1703)': '0.0190',
                        'Windows 10 FCU (1709)': '0.0465',
                        'Windows 10 A18U (1803)': '0.8851',
                        'Windows 10 O18U (1809)': '0.0228',
                    },
                    {
                        'date': '11/27/2018',
                        'Windows 10 (1507)': '0.0022',
                        'Windows 10 (1511)': '0.0043',
                        'Windows 10 AU (1607)': '0.0141',
                        'Windows 10 CU (1703)': '0.0153',
                        'Windows 10 FCU (1709)': '0.0389',
                        'Windows 10 A18U (1803)': '0.8968',
                        'Windows 10 O18U (1809)': '0.0284',
                    },
                    {
                        'date': '12/27/2018',
                        'Windows 10 (1507)': '0.0026',
                        'Windows 10 (1511)': '0.0048',
                        'Windows 10 AU (1607)': '0.0136',
                        'Windows 10 CU (1703)': '0.0177',
                        'Windows 10 FCU (1709)': '0.0575',
                        'Windows 10 A18U (1803)': '0.8380',
                        'Windows 10 O18U (1809)': '0.0658',
                    },
                    {
                        'date': '1/28/2019',
                        'Windows 10 (1507)': '0.0019',
                        'Windows 10 (1511)': '0.0042',
                        'Windows 10 AU (1607)': '0.0118',
                        'Windows 10 CU (1703)': '0.0136',
                        'Windows 10 FCU (1709)': '0.0405',
                        'Windows 10 A18U (1803)': '0.8034',
                        'Windows 10 O18U (1809)': '0.1246',
                    },
                    {
                        'date': '2/25/2019',
                        'Windows 10 (1507)': '0.0020',
                        'Windows 10 (1511)': '0.0044',
                        'Windows 10 AU (1607)': '0.0126',
                        'Windows 10 CU (1703)': '0.0134',
                        'Windows 10 FCU (1709)': '0.0373',
                        'Windows 10 A18U (1803)': '0.7179',
                        'Windows 10 O18U (1809)': '0.2124',
                    },
                    {
                        'date': '3/26/2019',
                        'Windows 10 (1507)': '0.0025',
                        'Windows 10 (1511)': '0.0053',
                        'Windows 10 AU (1607)': '0.0134',
                        'Windows 10 CU (1703)': '0.0134',
                        'Windows 10 FCU (1709)': '0.0353',
                        'Windows 10 A18U (1803)': '0.6654',
                        'Windows 10 O18U (1809)': '0.2648',
                    },
                    {
                        'date': '4/26/2019',
                        'Windows 10 (1507)': '0.0021',
                        'Windows 10 (1511)': '0.0055',
                        'Windows 10 AU (1607)': '0.0135',
                        'Windows 10 CU (1703)': '0.0139',
                        'Windows 10 FCU (1709)': '0.0329',
                        'Windows 10 A18U (1803)': '0.6369',
                        'Windows 10 O18U (1809)': '0.2951',
                    },
                    {
                        // interpolated values
                        'date': '5/21/2019',
                        'Windows 10 (1507)': '0.0019',
                        'Windows 10 (1511)': '0.0056',
                        'Windows 10 AU (1607)': '0.0136',
                        'Windows 10 CU (1703)': '0.0143',
                        'Windows 10 FCU (1709)': '0.0310',
                        'Windows 10 A18U (1803)': '0.6140',
                        'Windows 10 O18U (1809)': '0.3195',
                        'Windows 10 M19U (1903)': '0',
                    },
                    {
                        'date': '5/28/2019',
                        'Windows 10 (1507)': '0.0022',
                        'Windows 10 (1511)': '0.0052',
                        'Windows 10 AU (1607)': '0.0127',
                        'Windows 10 CU (1703)': '0.0122',
                        'Windows 10 FCU (1709)': '0.0287',
                        'Windows 10 A18U (1803)': '0.6119',
                        'Windows 10 O18U (1809)': '0.3134',
                        'Windows 10 M19U (1903)': '0.0137',
                    },
                    {
                        'date': '6/26/2019',
                        'Windows 10 (1507)': '0.0020',
                        'Windows 10 (1511)': '0.0046',
                        'Windows 10 AU (1607)': '0.0112',
                        'Windows 10 CU (1703)': '0.0116',
                        'Windows 10 FCU (1709)': '0.0255',
                        'Windows 10 A18U (1803)': '0.5814',
                        'Windows 10 O18U (1809)': '0.3004',
                        'Windows 10 M19U (1903)': '0.0632',
                    },
                    {
                        'date': '7/25/2019',
                        'Windows 10 (1507)': '0.0015',
                        'Windows 10 (1511)': '0.0041',
                        'Windows 10 AU (1607)': '0.0104',
                        'Windows 10 CU (1703)': '0.0106',
                        'Windows 10 FCU (1709)': '0.0238',
                        'Windows 10 A18U (1803)': '0.5376',
                        'Windows 10 O18U (1809)': '0.2980',
                        'Windows 10 M19U (1903)': '0.1141',
                    },
                    {
                        'date': '8/27/2019',
                        'Windows 10 (1507)': '0.0017',
                        'Windows 10 (1511)': '0.0046',
                        'Windows 10 AU (1607)': '0.0112',
                        'Windows 10 CU (1703)': '0.0103',
                        'Windows 10 FCU (1709)': '0.0219',
                        'Windows 10 A18U (1803)': '0.3314',
                        'Windows 10 O18U (1809)': '0.2880',
                        'Windows 10 M19U (1903)': '0.3309',
                    },
                    {
                        'date': '9/25/2019',
                        'Windows 10 (1507)': '0.0016',
                        'Windows 10 (1511)': '0.0047',
                        'Windows 10 AU (1607)': '0.0100',
                        'Windows 10 CU (1703)': '0.0102',
                        'Windows 10 FCU (1709)': '0.0194',
                        'Windows 10 A18U (1803)': '0.2421',
                        'Windows 10 O18U (1809)': '0.2553',
                        'Windows 10 M19U (1903)': '0.4566',
                    },
                    {
                        'date': '10/28/2019',
                        'Windows 10 (1507)': '0.0015',
                        'Windows 10 (1511)': '0.0044',
                        'Windows 10 AU (1607)': '0.0098',
                        'Windows 10 CU (1703)': '0.0093',
                        'Windows 10 FCU (1709)': '0.0183',
                        'Windows 10 A18U (1803)': '0.1366',
                        'Windows 10 O18U (1809)': '0.2515',
                        'Windows 10 M19U (1903)': '0.5686',
                    },
                ],
      surfaceData: [{Device: 'Surface\nPro 4', Share: 0.2007},
                    {Device: 'Surface\nPro (2017)', Share: 0.1703},
                    {Device: 'Surface\nPro 6', Share: 0.1253},
                    {Device: 'Surface\nPro 3', Share: 0.1250},
                    {Device: 'Surface\nGo', Share: 0.1218},
                    {Device: 'Surface\n3', Share: 0.0602},
                    {Device: 'Surface\nBook 2', Share: 0.0428},
                    {Device: 'Surface\nBook', Share: 0.0400},
                    {Device: 'Surface\nLaptop', Share: 0.0336},
                    {Device: 'Surface\nPro 1', Share: 0.0255},
                    {Device: 'Surface\nLaptop 2', Share: 0.0241},
                    {Device: 'Surface\nPro 2', Share: 0.0227},
                    {Device: 'Surface\nPro 7', Share: 0.0046},
                    {Device: 'Surface\nStudio 2', Share: 0.0014},
                    {Device: 'Surface\nLaptop 3', Share: 0.0014},
                    {Device: 'Surface\nStudio', Share: 0.0007}],
    };
  },

  mounted() {
    // this.osWorldwideData = ;
  },
});
